import { Box } from '@nimbus-ds/components';
import googleIcon from '../icons/google.png';
import metaIcon from '../icons/meta.png';
import tiktokIcon from '../icons/tiktok.png';

interface PromoteIconProps {
  type: string;
  isPromoteGrouped?: boolean;
}

const getIcon = (type) => {
  switch (type) {
    case 'google':
      return googleIcon;
    case 'meta':
      return metaIcon;
    case 'tiktok':
      return tiktokIcon;
    default:
      return googleIcon;
  }
};

function PromoteIcon({
  type,
  isPromoteGrouped = false,
}: Readonly<PromoteIconProps>) {
  if (isPromoteGrouped) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center">
        <img alt="promote-icon" width={16} src={getIcon(type)} />
      </Box>
    );
  }

  return (
    <div className="icon-container-promote">
      <img alt="promote-icon" src={getIcon(type)} />
    </div>
  );
}

export default PromoteIcon;
